/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddFittingPopupComponent } from './add-fitting-popup.component';
import { SysqueFrameModule } from '../../../../../../shared/ui/src/lib/components/sysque-frame';
import { AddFittingModeModule } from '../add-fitting-mode';
import { ManageModeModule } from '../manage-mode';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  { path: 'dialog/add-fitting', component: AddFittingPopupComponent }
];

@NgModule({
  declarations: [
    AddFittingPopupComponent
  ],
  imports: [
    CommonModule,
    SysqueFrameModule,
    AddFittingModeModule,
    ManageModeModule,
    RouterModule.forChild(routes)
  ],
  exports: [
    AddFittingPopupComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AddFittingPopupModule { }